export const CLOCK_SKEW_BUFFER_SECONDS = 300; // 5 minute buffer for clock skew
